import {
  HTTP_COPYMONTHBUDGET_FETCHING,
  HTTP_COPYMONTHBUDGET_SUCCESS,
  HTTP_COPYMONTHBUDGET_FAILED,
  HTTP_RESET_COPYMONTHBUDGET,
  server,
} from "src/Constants";
import Axios from "axios";
import { httpClient } from "src/utils/HttpClient";

//insert Budgets
export const setStateCopyMonthBudgetToFetching = () => ({
  type: HTTP_COPYMONTHBUDGET_FETCHING,
});

export const setStateCopyMonthBudgetToSuccess = (payload) => ({
  type: HTTP_COPYMONTHBUDGET_SUCCESS,
  payload,
});

export const setStateCopyMonthBudgetToFailed = (payload) => ({
  type: HTTP_COPYMONTHBUDGET_FAILED,
});

export const copyMonthBudget = (item) => {
  return async (dispatch) => {
    dispatch(setStateCopyMonthBudgetToFetching());
    try {
      await httpClient.post(`${server.COPYMONTHBUDGET_URL}`, item);
      dispatch(setStateCopyMonthBudgetToSuccess("success"));
    } catch (error) {
      dispatch(setStateCopyMonthBudgetToFailed());
    }
  };
};
